import { apiService } from './apiService';

export const seyirViolationService = {
  async getViolations(params?: { startDate?: string; endDate?: string; todayOnly?: boolean; limit?: number }) {
    const queryParams = new URLSearchParams();
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    if (params?.todayOnly) queryParams.append('todayOnly', '1');
    if (params?.limit) queryParams.append('limit', String(params.limit));
    const query = queryParams.toString();
    return apiService.get(`/seyir-violations${query ? `?${query}` : ''}`);
  },

  async scanNow() {
    return apiService.post('/seyir-violations/scan', {});
  },
};
